package com.example.mystybag.appCore.logic.addMerchantLocation

import com.example.mystybag.appCore.model.addMerchantLocation.BusinessCategoryItem

internal fun coverPresetUrlsLooselyEqual(a: String, b: String): Boolean {
    val ta = a.trim()
    val tb = b.trim()
    if (ta == tb) return true
    val na = ta.trimEnd('/').lowercase()
    val nb = tb.trimEnd('/').lowercase()
    if (na == nb) return true
    val baseA = ta.substringBefore('?').trimEnd('/').lowercase()
    val baseB = tb.substringBefore('?').trimEnd('/').lowercase()
    if (baseA == baseB) return true
    val httpsA = ta.replaceFirst(Regex("^http://", RegexOption.IGNORE_CASE), "https://")
    val httpsB = tb.replaceFirst(Regex("^http://", RegexOption.IGNORE_CASE), "https://")
    if (httpsA.trimEnd('/').lowercase() == httpsB.trimEnd('/').lowercase()) return true
    return false
}

/** Index in [BusinessCategoryItem.coverImageUrls] matching saved location cover, or null. */
internal fun indexOfMatchingCoverPreset(
    existingCoverUrl: String?,
    category: BusinessCategoryItem?
): Int? {
    if (existingCoverUrl.isNullOrBlank() || category == null) return null
    val idx = category.coverImageUrls.indexOfFirst { preset ->
        coverPresetUrlsLooselyEqual(existingCoverUrl, preset)
    }
    return idx.takeIf { it >= 0 }
}
